<template>
  <div>
    <secondHeader />
    <div class="rules-main">
      <sidebar />
      <main class="rules-content">
        <div class="rules-container">
          <!-- Hero Section -->
          <section class="rules-hero">
            <div class="rules-hero-content">
              <h1 class="rules-hero-title">
                <svg class="rules-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 0 002-2v-7"></path>
                </svg>
                ご利用のルール
              </h1>
              <p class="rules-hero-description">はいしんツールキットの利用規約・サポート情報</p>
            </div>
          </section>

          <!-- Rules Section -->
          <section class="rules-grid-section">
            <div class="rules-grid">
              <article class="rules-card">
                <div class="rules-card-header">
                  <h2 class="rules-card-title">サービスについて</h2>
                </div>
                <div class="rules-card-content">
                  <p>「はいしんツールキット」は「<a href="https://www.ruri.info/" target="_blank" rel="noopener noreferrer">ruri.info</a>」が運営する、ライブ配信活動のサポートツールです。</p>
                </div>
              </article>

              <article class="rules-card">
                <div class="rules-card-header">
                  <h2 class="rules-card-title">利用について</h2>
                </div>
                <div class="rules-card-content">
                  <p>商用利用OK。個人、法人問わず活動に利用できます。</p>
                  <p>ご使用にあたり、報告やクレジット表記の義務はありません。</p>
                  <p>もし記載いただける場合は下記をお願いします。</p>
                  <div class="credit-highlight">
                    <code class="credit-text">はいしんツールキット(https://ruri.info/tool/)</code>
                  </div>
                </div>
              </article>

              <article class="rules-card">
                <div class="rules-card-header">
                  <h2 class="rules-card-title">お問い合わせ</h2>
                </div>
                <div class="rules-card-content">
                  <p>不明点、リクエスト、ご質問などは開発者のTwitter(<a href="https://twitter.com/syou_config" target="_blank" rel="noopener noreferrer">@syou_config</a>)まで遠慮なくご連絡ください！</p>
                  <p>「こんなツールが欲しい！」とかも大歓迎です。</p>
                </div>
              </article>
            </div>
          </section>

          <!-- Ad Section -->
          <section class="rules-ad-block">
            <div class="rules-ad">
              <InFeedAdsense
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-9016794589237931"
                  data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue";
import sidebar from "../components/sidebar.vue"

export default {
  components: {
    secondHeader,
    sidebar,
  },
    data(){
      return{
        isProduction: process.env.NODE_ENV === "production",
      }
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

/* Global Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Main Layout */
.rules-main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  font-family: 'Outfit', system-ui, -apple-system, sans-serif;
}

.rules-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.rules-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* Hero Section */
.rules-hero {
  padding: 80px 0 60px 0;
  text-align: center;
}

.rules-hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.rules-hero-title {
  font-size: 2rem;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 16px;
  letter-spacing: -0.025em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.rules-icon {
  width: 32px;
  height: 32px;
  color: #0f172a;
  flex-shrink: 0;
}

.rules-hero-description {
  font-size: 1rem;
  color: #0f172a;
  font-weight: 400;
  line-height: 1.6;
}

/* Rules Grid Section */
.rules-grid-section {
  padding: 0 0 80px 0;
}

.rules-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  max-width: 800px;
  margin: 0 auto;
}

/* Rules Cards */
.rules-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.rules-card-header {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  padding: 24px 32px;
}

.rules-card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.025em;
}

.rules-card-content {
  padding: 32px;
}

.rules-card-content p {
  font-size: 1rem;
  line-height: 1.7;
  color: #4a5568;
  margin-bottom: 16px;
}

.rules-card-content p:last-child {
  margin-bottom: 0;
}

.rules-card-content a {
  color: #0f172a;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
  border-bottom: 1px solid #e2e8f0;
}

.rules-card-content a:hover {
  color: #1e293b;
  border-bottom-color: #0f172a;
}

/* Credit Highlight */
.credit-highlight {
  margin-top: 16px;
  background: #f8fafc;
}

.credit-text {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.9rem;
  color: #0f172a;
  background: #f8fafc;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  display: inline-block;
  font-weight: 500;
}

/* Ad Section */
.rules-ad-block {
  padding: 40px 0 40px 0;
  background: #f8fafc;
}

.rules-ad {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

/* Responsive Design */
@media screen and (max-width: 1024px) {
  .rules-container {
    padding: 0 20px;
  }
  
  .rules-hero-title {
    font-size: 2.5rem;
  }
  
  .rules-icon {
    width: 40px;
    height: 40px;
  }
}

@media screen and (max-width: 768px) {
  .rules-main {
    flex-direction: column;
  }
  
  .rules-container {
    padding: 0 16px;
  }
  
  .rules-hero {
    padding: 60px 0 40px 0;
  }
  
  .rules-hero-title {
    font-size: 2rem;
    flex-direction: column;
    gap: 12px;
  }
  
  .rules-hero-description {
    font-size: 1.1rem;
  }
  
  .rules-grid {
    gap: 24px;
  }
  
  .rules-card-header {
    padding: 20px 24px;
  }
  
  .rules-card-title {
    font-size: 1.3rem;
  }
  
  .rules-card-content {
    padding: 24px;
  }
  
  .rules-card-content p {
    font-size: 0.95rem;
  }
}

@media screen and (max-width: 480px) {
  .rules-container {
    padding: 0 12px;
  }
  
  .rules-hero-title {
    font-size: 1.75rem;
  }
  
  .rules-icon {
    width: 32px;
    height: 32px;
  }
  
  .rules-card-header {
    padding: 16px 20px;
  }
  
  .rules-card-title {
    font-size: 1.2rem;
  }
  
  .rules-card-content {
    padding: 20px;
  }
  
  .credit-text {
    font-size: 0.8rem;
    padding: 6px 10px;
  }
}
</style>